import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FlexGap, Input, Label, Tags } from '@treams/treams-ui';

export function DurationInput(props: {
	value: number;
	onChange: (value: number) => void;
	disabled?: boolean;
}) {
	const { t } = useTranslation();
	const presets = [15, 30, 60];

	return (
		<FlexGap gap={8} flexDirection="column">
			<Label>{t('meeting.duration.labelAlternative')}</Label>
			<DurationPickerWrapper>
				<Input
					value={String(props.value)}
					type="number"
					onChange={(value) => props.onChange(Number(value))}
					inputProps={{ step: 5, min: 5, max: 120 }}
					suffix={t('common.time.minutes')}
					disabled={props.disabled}
				/>
				{presets.map((preset, index) => (
					<Tags.Item
						key={index}
						value={`${preset} ${t('common.time.minutesAbbreviated')}`}
						onClick={props.disabled ? undefined : () => props.onChange(preset)}
						selected={props.value === preset}
					/>
				))}
			</DurationPickerWrapper>
		</FlexGap>
	);
}

const DurationPickerWrapper = styled(FlexGap).attrs({
	gap: 4,
	alignItems: 'center',
})`
	--size: 40px;

	> :not(:first-child) {
		height: var(--size);
		border-radius: 6px;
	}

	input {
		// Fixes height alignment as the input uses a box shadow to emulate a border.
		height: calc(var(--size) - 1px);
	}

	> :first-child {
		margin-right: 4px;
		width: unset !important;
		flex-grow: 1;
	}
`;
